// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
// import { ViewCell } from 'ng2-smart-table';
import { Model } from './common/.base.model';
import { Assignment } from './assignment';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface';

export interface Role extends Model {
  title: string;
  description?: string;
  assignments?: Assignment[];
  file?: any;
}

export const RoleConfig: EntityConfigTemplate = {
  meta: { entityName: 'role', entityPluralName: 'roles', titleField: 'title', view: false },
  title: { title: 'Title' },
  description: { title: 'Description' },
  assignments: { isForeignKey: true, title: 'Assignments', valuePrep: (_cell_, row) => `${row?.assignments?.length | 0}` },
  file: { title: 'File', type: 'file', view: { list: false } },
};

export const RoleFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: "Role Details",
      columns: [
        {
          size: "col-12",
          type: "form",
          sections: [
            {
              title: "Role Details",
              rows: [
                {
                  fields: [
                    { name: "title", label: "Title", type: "text", required: true, size: "col-6" },
                    { name: "file", label: "File", type: "file", size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "description", label: "Description", type: "textarea", required: false, size: "col-12" },
                  ]
                },
              ],
            }
          ],
        },
      ],
    },
  ],
};

export abstract class RoleData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Role[]>;
  abstract listAll(): Observable<Role[]>;
  abstract get(id: string): Observable<Role>;
  abstract update(Department: Role): Observable<Role>;
  abstract create(Department: Role): Observable<Role>;
  abstract delete(id: string): Observable<boolean>;
}